/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as ActionTypes from "constants/ActionTypes";
import { AddToastAction, RemoveToastAction } from "types/Actions";
import { AppAction } from "types/AppAction";
import { ToastVariants } from "@spectrum-web-components/toast";

export function addToast({
  message,
  variant,
}: {
  message: string;
  variant?: ToastVariants;
}): AddToastAction {
  return {
    type: ActionTypes.ADD_TOAST,
    toastMessage: message,
    variant: variant,
  };
}

export function removeToast(id: string): RemoveToastAction {
  return {
    type: ActionTypes.REMOVE_TOAST,
    id,
  };
}
